export function arredondarMoeda(valor) {
  return Math.round(Number(valor) * 100) / 100;
}

export function formatarMoedaBrl(valor) {
  return arredondarMoeda(valor).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function obterPrecoProcedimento(item) {
  return Number(item.precoAplicado ?? item.precoExame ?? 0);
}

export function obterQuantidadeProcedimento(item) {
  const quantidade = Number(item.quantidade ?? 1);
  return quantidade >= 1 ? quantidade : 1;
}

export function calcularSubtotal(procedimentos) {
  return arredondarMoeda(
    procedimentos.reduce(
      (sum, item) => sum + obterPrecoProcedimento(item) * obterQuantidadeProcedimento(item),
      0
    )
  );
}

export function parseDesconto(valor) {
  if (valor === "" || valor === null || valor === undefined) {
    return 0;
  }

  const numero = Number(valor);
  if (!Number.isFinite(numero)) {
    return NaN;
  }

  return arredondarMoeda(numero);
}

export function validarDesconto(descontoRaw, subtotal) {
  const subtotalArredondado = arredondarMoeda(subtotal);
  const desconto = parseDesconto(descontoRaw);

  if (Number.isNaN(desconto)) {
    return {
      valido: false,
      mensagem: "Informe um desconto válido em reais.",
    };
  }

  if (desconto < 0) {
    return {
      valido: false,
      mensagem: "O desconto não pode ser negativo.",
    };
  }

  if (subtotalArredondado <= 0 && desconto > 0) {
    return {
      valido: false,
      mensagem: "Não é possível aplicar desconto sem procedimentos com valor.",
    };
  }

  if (desconto > subtotalArredondado + 0.001) {
    return {
      valido: false,
      mensagem: `O desconto não pode ser maior que o subtotal (${formatarMoedaBrl(subtotalArredondado)}).`,
    };
  }

  return {
    valido: true,
    desconto,
    subtotal: subtotalArredondado,
    totalLiquido: arredondarMoeda(subtotalArredondado - desconto),
  };
}

export function formatarTotalExibicao(procedimentos, descontoRaw) {
  const subtotal = calcularSubtotal(procedimentos);

  if (subtotal <= 0) {
    return formatarMoedaBrl(0);
  }

  const resultado = validarDesconto(descontoRaw, subtotal);
  if (resultado.valido) {
    return formatarMoedaBrl(resultado.totalLiquido);
  }

  const descontoInformado = parseDesconto(descontoRaw) || 0;
  return formatarMoedaBrl(Math.max(0, subtotal - descontoInformado));
}
